import React from "react";
import "./LeftHandSideMenu.scss";
import { NavLink, useLocation } from "react-router-dom";

const LeftHandSideMenu = () => {
  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  return (
    <>
      <div className="sidebar-section">
        <div className="sidebar-header">
          <h2 className="sidebar-header-text">
            <span>Main</span>
          </h2>
        </div>

        <ul className="sidebar-nav-list">
          <li className="sidebar-nav-item">
            <div className="sidebar-nav-link">
              <span className="nav-item-icon nav-icon-dashboard"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/dashboard"
                  to={`/practice/${practiceId}/profile-information/dashboard`}
                >
                  Dashboard
                </NavLink>
              </span>
            </div>
          </li>
          <li className="sidebar-nav-item">
            <div className="sidebar-nav-link">
              <span className="nav-item-icon nav-icon-practice"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/practice"
                  to={`/practice/${practiceId}/profile-information/info`}
                >
                  Practice
                </NavLink>
              </span>
            </div>
          </li>
          <li className="sidebar-nav-item">
            <div className="sidebar-nav-link">
              <span className="nav-item-icon nav-icon-provider"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/provider"
                  to={`/practice/${practiceId}/profile-information/provider`}
                >
                  Providers
                </NavLink>
              </span>
            </div>
          </li>
          <li className="sidebar-nav-item">
            <div className="sidebar-nav-link">
              <span className="nav-item-icon nav-icon-review"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/reviews"
                  to={`/practice/${practiceId}/profile-information/reviews`}
                >
                  Reviews <span className="new-review">New</span>
                </NavLink>
              </span>
            </div>
          </li>
        </ul>
      </div>

      <div className="sidebar-section">
        <div className="sidebar-header">
          <h2 className="sidebar-header-text">
            <span>Admin</span>
          </h2>
        </div>

        <ul className="sidebar-nav-list">
          <li className="sidebar-nav-item">
            {/* <a  className="sidebar-nav-link">
              <span className="nav-item-icon nav-icon-manage-user"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/manageusers"
                  to={`/practice/${practiceId}/profile-information/manageusers`}
                >
                  Manage Users
                </NavLink>
              </span>
            </a> */}
            <div className="sidebar-nav-item">
              <span className="nav-item-icon nav-icon-manage-user"></span>
              <span className="nav-item-text">
                <NavLink
                  // to="/practice/profileinformation/manageusers"
                  to={`/practice/${practiceId}/profile-information/manageusers`}
                >
                  Manage Users
                </NavLink>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};
export default LeftHandSideMenu;
